import {
  AE_BROKER_QUALITY_SCORECARD_LOANS_URL,
  AE_BROKER_QUALITY_SCORECARD_UNDERWRITING_URL,
  DEFAULT_AE_QUALITY_SCORECARD_WINDOW_DAYS,
} from './aeBrokerQualityApi.constants';

/**
 * AE per-broker file-quality scorecard client (DEV-3781). Same two-gateway split
 * the broker-facing zone uses (DEV-3777), but the internal AE path carries an
 * explicit subCompanyId so an AE can read each of their brokers' scorecards:
 *
 *   GET /api/brokerQualityScorecard?subCompanyId=<id>&windowDays=90 (Underwriting)
 *     → conditions-cleared-within-SLA %, condition-clearing turn-time median
 *   GET /api/brokerQualityScorecardMetrics?subCompanyId=<id>&windowDays=90 (Loans)
 *     → broker-owned time-in-status median
 *
 * Each half nulls the keys it does not own; the slice merges them. Both halves
 * 404 when the backend feature toggle is off — the slice treats that as "not
 * available". A 403 (auth gap) degrades the same way, so callers pass
 * skipResponseInterceptor forbiddenError to avoid the global page-reload loop.
 *
 * Response shape (identical to the broker-facing halves):
 *   { metrics, sampleSizes, programMixNote, windowDays, asOf, evaluatedAgainst,
 *     metricFlags }
 */
export class AeBrokerQualityScorecardApi {
  #underwritingHttp;
  #loansHttp;

  constructor(underwritingHttp, loansHttp) {
    this.#underwritingHttp = underwritingHttp;
    this.#loansHttp = loansHttp;
  }

  async getUnderwritingScorecard({
    subCompanyId,
    windowDays = DEFAULT_AE_QUALITY_SCORECARD_WINDOW_DAYS,
    config = {},
  }) {
    return this.#underwritingHttp.get(AE_BROKER_QUALITY_SCORECARD_UNDERWRITING_URL, {
      ...config,
      params: { subCompanyId, windowDays },
    });
  }

  async getLoansScorecard({
    subCompanyId,
    windowDays = DEFAULT_AE_QUALITY_SCORECARD_WINDOW_DAYS,
    config = {},
  }) {
    return this.#loansHttp.get(AE_BROKER_QUALITY_SCORECARD_LOANS_URL, {
      ...config,
      params: { subCompanyId, windowDays },
    });
  }
}
